import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import { LeftOutlined } from "@ant-design/icons";
import type { RadioChangeEvent } from "antd";
import "./play.less";
import {
  Avatar,
  Dropdown,
  Menu,
  message,
  Tabs,
  Tooltip,
  Button,
  Space,
  Modal,
  Radio,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import axios from "@/axios/axios";
import { ranDomNum } from "@/common/utils";
import VedioImg from "@/vedio.png";
import { log } from "console";
import Evaluation from "@/components/evaluation";
import { CameraComponent } from "@/components/faceRecognition";
import {
  CCvideoControlInstance,
  AlivideoControlInstance,
} from "@/common/video";
const { TabPane } = Tabs;
// 当前哪个视频
let currentIndex = 0;
let waitPayStatus: string | number | NodeJS.Timeout | null | undefined = null;
const Play: FC<any> = ({
  history,
  match,
  storeData,
  setVideoStatus,
  dispatchUserInfo,
  dispatchUser,
}) => {
  const { userInfo } = storeData;
  const [courseInfo, setCourseInfo] = useState({} as any);
  const [myVideoTeacherInfoList, setMyVideoTeacherInfoList] = useState([]);
  let { courseId, sectionId } = match.params;
  const [obj, setObj] = useState({ courseId, sectionId } as any);
  // 视频播放
  const [videoTeacherInfoList, setVideoTeacherInfoList] = useState<any>({});
  const [sectionList, setSectionList] = useState<any>([]);
  const [evaluateOpen, setEvaluateOpen] = useState(false);
  const [livePlayer, setLivePlayer] = useState<any>(null);
  const [examNeedFaceFlag, setExamNeedFaceFlag] = useState(false);
  const [showFaceModal, setShowFaceModal] = useState(false);
  const [payCode, setPayCode] = useState("");
  // 视频类型 1:cc 3:阿里云
  const [videoSource, setVideoSource] = useState<"" | number>(3);
  const [payStatus, setPayStatus] = useState({
    /**是否需要支付 */
    needPay: false,
    /**价格 */
    price: 0,
    /**学时 */
    quantity: 0,
    /**产品名称 */
    productName: "",
    /**默认微信支付 */
    type: 1,
    /**产品ID */
    productId: "",
    /**支付金额 */
    orderAmount: 0,
  });
  const [payType, setPayType] = useState(1);
  const [showPayModal, setShowPayModal] = useState(false);
  const {
    REACT_APP_PDF_DOMAIN,
    REACT_APP_PDF_URL,
    REACT_APP_BASE_CONTINUE,
    REACT_APP_EXAM_URL,
    REACT_APP_EXAM_RECORD_URL,
  } = process.env;
  const menu = (
    <Menu>
      <Menu.Item>
        <Link to="/index/personCenter">学习记录</Link>
      </Menu.Item>
      <Menu.Item>
        <div
          onClick={() => {
            logOut();
          }}
        >
          退出
        </div>
      </Menu.Item>
    </Menu>
  );
  /**
   * 获取用户是否需要人脸
   */
  const getUserNeedFaceFlag = async () => {
    const { faceImageStatus, sectionNeedFaceFlag, specialUserFlag } = userInfo;
    // 0:不需要人脸 1:需要人脸
    if (sectionNeedFaceFlag === 1 && specialUserFlag !== 1) {
      // 1:已录 0:未录
      if (faceImageStatus === 0) {
        Modal.info({
          title: "人脸识别",
          content: (
            <div>
              <p>
                学习需要进行人脸识别，您尚未进行人脸信息录入，请先下载《国家医学电子书包APP》，进行人脸建档后再进行考试。
              </p>
            </div>
          ),
          onOk() {
            history.go(-1);
          },
        });
      } else {
        setShowFaceModal(true);
      }
    } else {
      // 获取视频参数
      getSectionInfo();
    }
  };
  const logOut = async () => {
    // saga 示例,  dispatch 一个异步action并且传入参数
    // dispatchUser({ type: 'GET_USER_LIST', payload: { userInfo: { name: 'saga123'}} })
    const { success, message: msg }: any = await axios.post("/user/web/exit");
    if (success) {
      dispatchUser({ type: "SET_USER_INFO", payload: { userInfo: null } });
      history.replace("/index/home");
    } else {
      message.error(msg);
    }
  };
  const initVideo = (
    vid: string,
    siteid: string,
    progressbar_enable: number,
    watchStartTime: number,
    rate_allow_change: number
  ) => {
    if (window.createCCH5Player) {
      window.ccPlayerStatus = window.createCCH5Player({
        vid,
        siteid,
        autoStart: false,
        width: "100%",
        height: "260px",
        banDrag: "true",
        playtype: 1,
        rate_allow_change: rate_allow_change ? true : false,
        // 是否可以拖动
        progressbar_enable: progressbar_enable,
        // 初始化观看时间
        watchStartTime,
        forceWasm: "true",
        parentNode: document.getElementById("livePlayer"),
      });
    }
  };
  /** 获取视频参数
   * @param {void}
   * @return {void}
   */
  const getSectionInfo = async () => {
    setVideoSource("");
    const { courseId, sectionId } = obj;
    axios
      .post(`/shop/front/ce/item/${courseId}/section/${sectionId}/info`)
      .then(async (res: any) => {
        if (res.code === 0) {
          let {
            data: {
              currentSection,
              sectionList,
              currentSectionTeacher,
              preventMoreOpenDialogFlag,
              canDragFlag,
              fastForwardFlag,
            },
          } = res;
          const {
            thirdVideoAccount,
            thirdVideoId,
            videoWatchAt = 0,
            itemId,
            id,
            videoDuration,
            examNeedFaceFlag = 0,
            trailWatchFinishToPayFlag = 0,
            videoSource,
            watchStatus,
            videoWatchProgress,
            watchAt,
          } = currentSection;
          // 课程学满可拖动
          if (canDragFlag === 3 && watchStatus === 1) {
            canDragFlag = 1;
          } else if (canDragFlag === 2) {
            canDragFlag = 1;
          } else {
            canDragFlag = 0;
          }
          if (fastForwardFlag === 3 && watchStatus === 1) {
            fastForwardFlag = 1;
          } else if (fastForwardFlag === 2) {
            fastForwardFlag = 1;
          } else {
            fastForwardFlag = 0;
          }
          setVideoTeacherInfoList(currentSectionTeacher);
          setCourseInfo(currentSection);
          setSectionList(sectionList);
          setExamNeedFaceFlag(examNeedFaceFlag);
          setVideoStatus({
            type: "SET_VIDEO_STATUS",
            vid: thirdVideoId,
            siteid: thirdVideoAccount,
            progressbar_enable: canDragFlag,
            rate_allow_change: fastForwardFlag,
            watchStartTime:watchAt,
            courseId: id,
            sectionId: itemId,
            videoDuration,
            preventMoreOpenDialogFlag,
            videoSource,
            projectId: itemId,
          });
          setVideoSource(videoSource);
          /**试听结束，需要付费 */
          if (trailWatchFinishToPayFlag === 1) {
            Modal.confirm({
              title: "试看已结束",
              content: `如需完整观看学习需支付费用，完成学习并考核合格可申请继教学分。`,
              okText: "继续学习",
              cancelText: "我再想想",
              onOk: () => {
                getPayInfo();
              },
              onCancel: () => {
                history.go(-1);
              },
            });
          } else {
            if (videoSource === 3) {
              initAliPlayer(currentSection);
            } else {
              initVideo(
                thirdVideoId,
                thirdVideoAccount,
                canDragFlag,
                watchAt,
                fastForwardFlag
              );
            }
          }
        }
      });
  };
  /**
   * 初始化阿里云
   * @param videoId
   */
  const initAliPlayer = async (sectionItem: any) => {
    const { thirdVideoId, watchAt = 0 } = sectionItem;
    const { data } = await axios.post(
      "/shop/front/ali/get/upload/play/auth",
      { videoId: thirdVideoId },
      false
    );
    const { playAuth } = data;
    // @ts-ignore
    window.aliPlayer = new Aliplayer(
      {
        id: "aliLivePlayer",
        vid: thirdVideoId,
        playauth: playAuth,
        qualitySort: "asc",
        format: "mp4",
        mediaType: "video",
        width: "100%",
        height: "100%",
        autoplay: false,
        isLive: false,
        rePlay: false,
        preload: false,
        useH5Prism: true,
        x5_type: "h5",
        // 启动同层播放
        playsinline: false,
        controlBarVisibility: "always",
      },
      (player: any) => {
        // 设置上次播放的时间
        player.seek(watchAt);
        // 设置倍速是否被允许
        AlivideoControlInstance.initAliPlayer(player); // 初始化阿里云播放相关方法
      }
    );
  };
  // 提交评价信息
  const submit = async (val: number, text: any) => {
    const { courseId, sectionId } = obj;
    const params = {
      content: text,
      itemId: courseId,
      sectionId,
      starLevel: val,
    };
    const { code, data, msg }: any = await axios.post(
      `/shop/front/ce/item/section/user/appraise/save`,
      params
    );
    if (code === 0) {
      message.success("评价成功");
      const data = { ...courseInfo };
      data.sectionAppraiseStatus = 1;
      setCourseInfo(data);
      setEvaluateOpen(false);
    } else {
      message.error(msg);
    }
  };
  useEffect(() => {
    getUserNeedFaceFlag();
    // getSectionInfo();
    return () => {
      window.ccPlayerStatus && window.ccPlayerStatus.destroy();
      window.ccPlayerStatus = null;
      window.video_end = null;
    };
  }, [obj]);
  //获取pdf路径
  const getPdfUrlBySectionId = (id: number) => {
    const { sectionId } = obj;
    return `${REACT_APP_PDF_DOMAIN}/static/common/pdfjs/generic/web/viewer.html?file=${REACT_APP_PDF_URL}/front/ce/section/file/preview/${id}`;
  };
  const play = (data: any) => {
    setObj({ courseId: data.itemId, sectionId: data.id });
  };
  const jumpExamRecord = (data: any) => {
    const { sectionId } = obj;
    const { existAnswerRecordFlag } = data;
    if (existAnswerRecordFlag === 1) {
      const url = `${REACT_APP_BASE_CONTINUE}${REACT_APP_EXAM_URL}/record-list?fromType=projectExam&itemId=${data.itemId}&sectionId=${sectionId}`;
      window.open(url);
    } else {
      message.warning("无答题记录");
    }
  };
  /**
   * 检查考试项目
   */
  const checkExam = async () => {
    if (examNeedFaceFlag) {
      setShowFaceModal(true);
    } else {
      const { courseId, sectionId } = obj;
      const { code, msg } = await axios.post(
        `/shop/exam/ce/check/item/${courseId}/section/${sectionId}/exam`
      );

      if (code === 0) {
        window.location.href = `${REACT_APP_BASE_CONTINUE}${REACT_APP_EXAM_URL}/exam-list/examList?fromType=projectExam&itemId=${courseId}&sectionId=${sectionId}`;
      } else {
        message.error(msg);
      }
    }
  };
  /**
   * 获取支付信息
   */
  const getPayInfo = async () => {
    const {
      data: { quantity, productName, productId, orderAmount },
    } = await axios.post(
      `/shop/front/ce/preview/item/${courseId}/order/info`,
      {}
    );
    setPayStatus({
      ...payStatus,
      quantity,
      productName,
      productId,
      orderAmount,
    });
    setShowPayModal(true);
  };
  const payTypeChange = (e: RadioChangeEvent) => {
    setPayType(e.target.value);
  };
  /**
   * 支付宝支付
   */
  const payAliOrder = async () => {
    const { productId, quantity } = payStatus;
    const { data } = await axios.post(
      "/shop/front/ce/pc/create/ali/pay/order",
      {
        productId,
        quantity,
        itemId: courseId,
      }
    );
    const { orderNo } = data;
    const returnUrl = encodeURIComponent(
      `${window.location.href}?currentPayTradeNo=${orderNo}`
    );
    window.location.href = `https://api.imed.org.cn/order/createAliPayOrder?payType=ALI_PAY&tradeNo=${orderNo}&returnUrl=${returnUrl}&tradeType=NATIVE`;
  };
  /**
   * 微信支付
   */
  const payWechatOrder = async () => {
    const { productId, quantity } = payStatus;
    const { data } = await axios.post(
      "/shop/front/ce/pc/create/wetChat/pay/order",
      {
        productId,
        quantity,
        itemId: courseId,
      }
    );
    const { tradeNo, weChatPayQrCode } = data;
    setPayCode(weChatPayQrCode);
    searchWechatPayStatus(tradeNo);
    setShowPayModal(false);
  };
  /**查询微信支付状态 */
  const searchWechatPayStatus = (tradeNo: string) => {
    waitPayStatus = setInterval(async () => {
      const {
        data: { code },
      } = await axios.post(`/shop/front/ce/order/${tradeNo}/pay/status`);
      if (code === 0) {
        clearInterval(waitPayStatus as number);
        setPayCode("");
        // 订单列表重定向查询
        window.location.href = `${window.location.href}?fromType=wechatPay`;
        // window.location.reload();
      }
    }, 3000);
  };
  return (
    <div className={"play"}>
      <div className={"header-box"}>
        <div
          className={"header-logo"}
          onClick={() => {
            history.goBack();
          }}
        >
          <LeftOutlined /> {courseInfo.courseName}
        </div>
        <div className={"header-user"}>
          {userInfo ? (
            <Link to="/index/personCenter">
              <h3 style={{ color: "#fff", fontWeight: "bold" }}>个人中心</h3>
            </Link>
          ) : (
            <span>
              <Link to="/index/home">未登录</Link>
            </span>
          )}
        </div>
      </div>
      <div className={"view"}>
        <div className={"left"}>
          <div className={"title"}>课件列表</div>
          <div>
            {sectionList.map((section: any, index: number) => (
              <div key={index}>
                <div className={"items-box"}>
                  <ul className={"items"}>
                    <li
                      className={
                        obj.sectionId == section.id ? "selectedColor" : ""
                      }
                      key={index}
                      onClick={() => {
                        currentIndex = index;
                        play(section);
                      }}
                    >
                      <img src={VedioImg} alt="" />
                      <p style={{ fontSize: "20px" }}>{section.sectionName}</p>
                    </li>
                    <div style={{ padding: "0 15px" }}>
                      <p>主讲人：{section.itemTeacher.name}</p>
                      <p>主讲单位：{section.itemTeacher.workUnit}</p>
                    </div>
                    <li>
                      <Space>
                        <Button
                          type="primary"
                          size="small"
                          shape="round"
                          style={{ background: "#999", borderColor: "#999" }}
                        >
                          {section.watchStatus ? "已学完" : "未学完"}
                        </Button>
                        <Button
                          type="primary"
                          shape="round"
                          size="small"
                          style={{ background: "#999", borderColor: "#999" }}
                        >
                          {section.examStatus ? "已通过" : "未通过"}
                        </Button>
                      </Space>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={"center"}>
          {videoSource === 1 && (
            <div id="livePlayer" style={{ height: "100%" }}></div>
          )}
          {videoSource === 3 && (
            <div id="aliLivePlayer" style={{ height: "100%" }}></div>
          )}
        </div>
        <div className={"right"}>
          <div className={"r-titles"}>讲师</div>
          <div className={"r-content"}>
            <div className={"r-content"}>
              <div
                className={"teacher-info"}
                style={{ minHeight: `calc(100% - 210px)` }}
              >
                <img src={videoTeacherInfoList.imageAllPath} alt="" />
              </div>
              <div className={"info"}>
                <h3>{videoTeacherInfoList.name}</h3>
                <h3>{videoTeacherInfoList.workUnit}</h3>
              </div>
              <p style={{ padding: "0 10px" }}>
                {videoTeacherInfoList.introduction}
              </p>
            </div>
            <div className={"btns"}>
              <span
                onClick={() => {
                  let url = getPdfUrlBySectionId(courseInfo.id);
                  window.open(url);
                }}
              >
                讲义
              </span>
              {/* 学习状态已通过，并且未评价 */}
              {courseInfo.sectionAppraiseStatus === 0 &&
              courseInfo.watchStatus === 1 ? (
                <span
                  onClick={() => {
                    setEvaluateOpen(true);
                  }}
                >
                  评价
                </span>
              ) : (
                <span style={{ background: "#999", color: "#fff" }}>评价</span>
              )}
              {/* 已评价并且观看完 */}
              {courseInfo.watchStatus === 1 &&
              courseInfo.sectionAppraiseStatus === 1 ? (
                <span onClick={() => checkExam()}>考试</span>
              ) : (
                <span style={{ background: "#999", color: "#fff" }}>考试</span>
              )}
              {courseInfo.existAnswerRecordFlag === 1 ? (
                <span onClick={() => jumpExamRecord(courseInfo)}>答题记录</span>
              ) : (
                <span style={{ background: "#999", color: "#fff" }}>
                  答题记录
                </span>
              )}
              <Evaluation
                open={evaluateOpen}
                onCancel={() => setEvaluateOpen(false)}
                submit={({ star, text }) => {
                  submit(star, text);
                }}
              ></Evaluation>
            </div>
            <CameraComponent
              showFaceModal={showFaceModal}
              obj={obj}
              setShowFaceModal={setShowFaceModal}
              examNeedFaceFlag={examNeedFaceFlag}
              onSuccess={() => {
                getSectionInfo();
              }}
            />
          </div>
        </div>
      </div>
      <Modal
        title="确认订单"
        open={showPayModal}
        onOk={() => {
          payType === 1 ? payWechatOrder() : payAliOrder();
        }}
        onCancel={() => {
          setShowPayModal(false);
        }}
      >
        <h3>{payStatus.productName}</h3>
        <p>学时：{payStatus.quantity}</p>
        <p>订单金额：¥{payStatus.orderAmount}</p>
        <p>
          <Radio.Group onChange={payTypeChange} value={payType}>
            <Radio value={1}>微信支付</Radio>
            <Radio value={2}>支付宝支付</Radio>
          </Radio.Group>
        </p>
      </Modal>
      {payCode && (
        <div className="weChatPayModal">
          <p
            onClick={() => {
              clearInterval(waitPayStatus as number);
              setPayCode("");
            }}
            className="back"
          >
            <Space>
              <ArrowLeftOutlined />
              返回
            </Space>
          </p>
          <div className="content">
            <h3>微信支付</h3>
            <p>请扫描二维码付款</p>
            <p>¥&nbsp;{payStatus.orderAmount}</p>
            <img src={payCode} alt="" />
          </div>
        </div>
      )}
    </div>
  );
};

// 兼容写法
export default connect(
  (state) => state,
  (dispatch) => {
    return {
      setVideoStatus: (param: any) => {
        dispatch({ ...param });
      },
      dispatchUserInfo: (param: any) => {
        dispatch({ ...param });
      },
      dispatchUser: (param: any) => {
        dispatch({ ...param });
      },
    };
  }
)(Play);
